import type { Feature } from './types';

import { getEnvValue } from '../utils';

const enabled = getEnvValue('NEXT_PUBLIC_MULTICHAIN_PORTFOLIO_ENABLED') === 'true';
const chainsConfigUrl = getEnvValue('NEXT_PUBLIC_MULTICHAIN_PORTFOLIO_CHAINS_URL');

const title = 'Multichain portfolio';

const config: Feature<{ chainsConfigUrl?: string }> = (() => {
  if (enabled) {
    return Object.freeze({
      title,
      isEnabled: true,
      ...(chainsConfigUrl ? { chainsConfigUrl } : {}),
    });
  }

  return Object.freeze({
    title,
    isEnabled: false,
  });
})();

export default config;
